var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Tabs',{attrs:{"value":_vm.activeName}},[_c('TabPane',{attrs:{"label":"仓租费","name":"storageFee"}},[_c('StorageFee',{attrs:{"close":_vm.close,"refresh":_vm.refresh}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }